// extracted by mini-css-extract-plugin
module.exports = {"bladePC":"detail_bladePC__BxT9h"};